module.exports = __webpack_public_path__ + "static/media/020.229ad64d.jpg";